export function validateEmail(mail: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)
}

export function validateUrl(url_string: string): boolean {
    return url_string.includes(".")
}
